export default __webpack_public_path__ + "static/media/about.5426ee61.png";